export default "__VITE_ASSET__C3A1NDUv__"